import type { RescheduleReason } from 'types';
import { baseQuery } from '../baseQuery';

export const getRescheduleReasons = async () => {
  const { data } = await baseQuery('reschedule-reasons');

  return data as RescheduleReason[];
};
